module.exports = __webpack_public_path__ + "assets_app/img/key_1.77448d68.svg";